import { Typography } from "antd"
import React, { useContext, useSyncExternalStore } from "react"
import { useTranslation } from "react-i18next"
import { ReactReduxContext } from "react-redux"

import type { RootState } from "../../store.ts"

const noSubscription = () => () => undefined

// Read from the store when there is one: the disclosure sits inside many forms
// that are also rendered on their own, without a store around them.
const useCompanyName = () => {
  const context = useContext(ReactReduxContext)
  const store = context?.store
  const value = useSyncExternalStore(
    store?.subscribe ?? noSubscription,
    () =>
      (store?.getState() as RootState | undefined)?.auth?.userInfo?.company_name
  )
  return typeof value === "string" ? value.trim() : ""
}

export const SmsConsentDisclosure = () => {
  const { t } = useTranslation()
  const companyName = useCompanyName()
  return (
    <Typography.Text
      type="secondary"
      className="block text-xs"
      data-sms-consent-disclosure
    >
      {t("smsConsentDisclosure.text", {
        company: companyName || t("smsConsentDisclosure.fallbackCompany")
      })}
    </Typography.Text>
  )
}
